import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as Highcharts from 'highcharts';
import { COMMON_CONSTANTS, COMMON_CONSTANTS_Percentage, COMMON_CONSTANTS_SNAPSHOT } from 'src/app/common/constants/common-constants';
import Stock from 'highcharts/modules/stock';


Stock(Highcharts);

import { HttpClient } from '@angular/common/http';
import { BarserviceService } from '../../barservice.service'
import { Observable } from 'rxjs/internal/Observable';
import { CustomsnapshotService } from 'src/app/modules/snapshot/Services/customsnapshot.service';
import { Subscription } from 'rxjs';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { SignificanceService } from 'src/app/common/services/significance.service';

@Component({
  selector: 'app-barchart01-custom',
  templateUrl: './barchart01.component.html',
  styleUrls: ['./barchart01.component.scss'] 
})
export class Barchart01ComponentCustom implements OnInit {
  chart: any;
  event: any;
  datalabel: any = false;
  barChartData: any;
  Highcharts: typeof Highcharts = Highcharts;
  seriesData: any = [];
  changeValue: any;
  properties: any;
  changeValueSeries: any;
  significance: any;
  sampleSize: any;
  data: any;
  defaultCategories1: any;
  max: any;
  min: any;
  maxBarValue = 0;
  public seriesData1: any[] = [];
  jsonData: any;
  categories: any;
  labels: any;
  significance2: any;
  selectedColor: any = "#ff0000";
  get maxDataPoints(): number {
    const dataPointCount = this.dataPointCount;
    const chartWidth = document.getElementById(`chart-container${this.id}`)?.clientWidth;

    if (!chartWidth) {
      return dataPointCount;
    }

    const minCategoryWidth = (this.popUp ? 120 : 80) + 40;
    return Math.min(dataPointCount, Math.max(1, Math.floor(chartWidth / minCategoryWidth)));
  }
  private get dataPointCount(): number {
    const plottedColumnCount = this.seriesData1.filter((series: any) => series.type === 'column').length;
    return plottedColumnCount || Math.max((this.categories?.length ?? 1) - 1, 0);
  }
  get visibleCategoryCount(): number {
    const dataPointCount = this.dataPointCount;
    return dataPointCount > 1
      ? Math.max(1, Math.min(dataPointCount, this.maxDataPoints) - 1)
      : dataPointCount;
  }
  get maxScrollOffset(): number {
    return Math.max(this.dataPointCount - this.visibleCategoryCount, 0);
  }
  get scrollThumbWidthPercent(): number {
    const dataPointCount = this.dataPointCount;
    if (dataPointCount === 0) {
      return 100;
    }
    return Math.max(8, (this.visibleCategoryCount / dataPointCount) * 100);
  }
  get scrollbarThumbColor(): string {
    return 'rgb(181, 183, 185)';
  }
  get scrollbarTrackColor(): string {
    return this.properties?.darkTheme
      ? this.barService.plotBandsdark
      : this.barService.plotBandsColor;
  }
  get scrollThumbLeftPercent(): number {
    if (this.maxScrollOffset === 0) {
      return 0;
    }
    return (this.scrollOffset / this.maxScrollOffset) * (100 - this.scrollThumbWidthPercent);
  }
  scrollOffset = 0;
  private isDraggingScrollbar = false;

  onScrollbarPointerDown(event: PointerEvent): void {
    if (this.maxScrollOffset === 0) {
      return;
    }
    const track = event.currentTarget as HTMLElement;
    track.setPointerCapture(event.pointerId);
    this.isDraggingScrollbar = true;
    this.updateScrollFromPointer(event.clientX, track);
  }

  onScrollbarPointerMove(event: PointerEvent): void {
    if (this.isDraggingScrollbar) {
      this.updateScrollFromPointer(event.clientX, event.currentTarget as HTMLElement);
    }
  }

  onScrollbarPointerUp(event: PointerEvent): void {
    this.isDraggingScrollbar = false;
    const track = event.currentTarget as HTMLElement;
    if (track.hasPointerCapture(event.pointerId)) {
      track.releasePointerCapture(event.pointerId);
    }
  }

  onScrollbarKeydown(event: KeyboardEvent): void {
    let nextOffset = this.scrollOffset;
    switch (event.key) {
      case 'ArrowLeft':
        nextOffset--;
        break;
      case 'ArrowRight':
        nextOffset++;
        break;
      case 'PageUp':
        nextOffset -= this.visibleCategoryCount;
        break;
      case 'PageDown':
        nextOffset += this.visibleCategoryCount;
        break;
      case 'Home':
        nextOffset = 0;
        break;
      case 'End':
        nextOffset = this.maxScrollOffset;
        break;
      default:
        return;
    }
    event.preventDefault();
    this.setScrollOffset(nextOffset, { duration: 140 });
  }

  private updateScrollFromPointer(clientX: number, track: HTMLElement): void {
    const rect = track.getBoundingClientRect();
    const thumbWidth = rect.width * this.scrollThumbWidthPercent / 100;
    const availableTrackWidth = rect.width - thumbWidth;
    if (availableTrackWidth <= 0) {
      return;
    }
    const thumbLeft = Math.min(
      Math.max(clientX - rect.left - thumbWidth / 2, 0),
      availableTrackWidth
    );
    this.setScrollOffset((thumbLeft / availableTrackWidth) * this.maxScrollOffset);
  }

  private setScrollOffset(offset: number, animation: boolean | Highcharts.AnimationOptionsObject = false): void {
    this.scrollOffset = Math.min(Math.max(offset, 0), this.maxScrollOffset);
    const min = this.scrollOffset + 1;
    this.chart?.xAxis[0].setExtremes(
      min,
      min + this.visibleCategoryCount - 1,
      true,
      animation
    );
  }
  maxSeries: any;
  categoryImages: any;
  userselectedchartdata: any;
  categoryColorMap: { [key: string]: string } = {};
    selectedMetric: any = '';
  hasCustomMetricIndex = false;
  hasCustomMetricSignificance = false;
  hasCustomMetricPercentage = false;
  constructor(private http: HttpClient, private _configService: SnapshotService, private route: ActivatedRoute, private barService: BarserviceService, private _customSnapshotService: CustomsnapshotService, private significanceService: SignificanceService, private cdr: ChangeDetectorRef) { }
  // ngOnInit(): void {

  //   this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
  //     this.jsonData = data;
  //     this.data = data[0];
  //     this.barChartData = data[0]["data"];
  //     this.properties = data[0]["properties"][0];
  //     this.properties.decimalRoundOff = 2;
  //     this.route.paramMap.subscribe((params) => {
  //       const userData = history.state.userData;
  //       this.userselectedchartdata = userData; // Use the userData object as needed
  //       if (this.userselectedchartdata?.widgetEditSelection) {
  //         if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
  //           this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
  //         }
  //       }
  //     });
  //     this.getData(this.jsonData, this.properties.datalabelStyle == "ls");

  //     this.getBarChart('chart-container'+this.id, this.seriesData1, this.properties);
  //   });
  // }
  private subscriptions: Subscription = new Subscription();
  DefaultConfidenceLevel: any = "";
  significanceValue: any = "None";
  Sig_LowerLimt = COMMON_CONSTANTS.SigLowerLimit_95;
  Sig_UpperLimt = COMMON_CONSTANTS.SigUpperLimit_95;
  configuredProperties: any;
  ngOnInit(): void {
    if (this.isOutput) {
      this.configuredProperties = JSON.parse(this.customData.customizationProperties);
      this.customData = this.customData.metric[0];
      this.applyCustomMetricExtensions();
      if (this.configuredProperties?.sort == "default") this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
      // this.data[0].metricSelected.metrics.sort((a: any, b: any) => a.selectorder - b.selectorder);
       const metricFromData = this.customData?.selectedMetric || '';
      
      if(this.configuredProperties?.sort=="default")this.customData.metric_value.sort((a: any, b: any) => a.selectOrder - b.selectOrder);
      this.selectedMetric = this._customSnapshotService.getSelectedMetricSync((Number(this.id) - 1000).toString()) || metricFromData;
      if (this.selectedMetric) {
        this.barService.selectedMetric = this.selectedMetric;
      }
          this.subscriptions.add(
        this._configService.significanceValue.subscribe(value => {
          this.significanceValue = value;
          this.updateSig();
        }));
      this.subscriptions.add(
        this._configService.confedenceValue.subscribe(value => {
          this.DefaultConfidenceLevel = value;
          this.updateSig();
        }));
    this.subscriptions.add(
        this._customSnapshotService.getSelectedMetric(this.id).subscribe((selectedMetric) => {
          if (selectedMetric) {
            this.selectedMetric = selectedMetric;
            this.barService.selectedMetric=this.selectedMetric; // Update the service with the new selection
            this.updateSig();
          }
        }));
    }
    else {
      this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
        this.jsonData = data;
        this.data = data[0];
        this.barChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties.decimalRoundOff = 2;
        this.properties.showLegend = true;
        this.route.paramMap.subscribe((params) => {
          const userData = history.state.userData;
          this.userselectedchartdata = userData; // Use the userData object as needed
          if (this.userselectedchartdata?.widgetEditSelection) {
            if (this.userselectedchartdata?.widgetEditSelection?.customizationProperties != "") {
              this.properties = JSON.parse(this.userselectedchartdata?.widgetEditSelection?.customizationProperties);
            }
          }
        });
        this.getData(this.jsonData, this.properties.datalabelStyle == "ls");

        this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
      });
    }

  }
  private applyCustomMetricExtensions(): void {

    const metrics = this.customData?.metric_value || [];

    this.hasCustomMetricIndex = false;
    this.hasCustomMetricSignificance = false;
    this.hasCustomMetricPercentage = false;

    metrics.forEach((metric: any) => {

      const extensions = metric.extensionOptions || [];

      if (
        extensions.some((e: any) =>
          e.id === 'index' && e.selected
        )
      ) {
        this.hasCustomMetricIndex = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'significance' && e.selected
        )
      ) {
        this.hasCustomMetricSignificance = true;
      }

      if (
        extensions.some((e: any) =>
          e.id === 'percentageSymbol' && e.selected
        )
      ) {
        this.hasCustomMetricPercentage = true;
      }
    });


  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['customData'] && !changes['customData'].firstChange) {
      if (this.isOutput) {
        this.configuredProperties = JSON.parse(this.customData.customizationProperties);
        this.customData = this.customData.metric[0];
        if (this.configuredProperties?.sort == 'default') this.customData.metric_value.sort((a: any, b: any) => a.selectorder - b.selectorder);
        this.updateSig();
      }
    }
  }

  updateSig() {
    this.updateSigSub?.unsubscribe();
    this.updateSigSub = this.http.get<any>('assets/Data/barData.json').subscribe((data: any) => {
        this.jsonData = data;
        //this.data = data[0];
        this.barChartData = data[0]["data"];
        this.properties = data[0]["properties"][0];
        this.properties = this.configuredProperties != undefined ? this.configuredProperties : this.properties;
        // this.properties.datalabelStyle = this.significanceValue == "None" ? "default" : "sigChange";
        // this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
      if (this.hasCustomMetricSignificance) {
        this.properties.datalabelStyle = "default";
      } else {
        this.properties.datalabelStyle =
          this.significanceValue == "None"
            ? "default"
            : "sigChange";
      }

      //this.properties.datalabelStyle = this._configService.isIndexSelected ? "index" : this.properties.datalabelStyle;
      if (
        this._configService.isIndexSelected &&
        !this.hasCustomMetricIndex
      ) {
        this.properties.datalabelStyle = "index";
      }
        this.Sig_LowerLimt = this.significanceService.getSigLowerLimit(this.DefaultConfidenceLevel, true);
        this.Sig_UpperLimt = this.significanceService.getSigUpperLimit(this.DefaultConfidenceLevel, true);
        this.scrollOffset = 0;
        this.preparemainChartData(this.customData, this.resolveMetricFilter(this.customData, this.selectedMetric));
        //this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
        this.getData(this.jsonData, this.properties.datalabelStyle == "ls");

        let docEle = document.getElementById('chart-container' + this.id)
        if (docEle != null) {
          docEle.innerHTML = '';
        }

        this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
        this.cdr.detectChanges();
    });
  }

  chartMainData: any = [];

  private get isAudienceSnapshot(): boolean {
    const snapshotType = (
      this._customSnapshotService.selectedSnapshotType?.name ||
      this._configService.selectedSnapshotType ||
      ''
    ).toLowerCase();
    return snapshotType.includes('audience');
  }
  private get isMultiMarketSnapshot(): boolean {
    const snapshotType = (
      this._customSnapshotService.selectedSnapshotType?.name ||
      this._configService.selectedSnapshotType ||
      ''
    ).toLowerCase();
    return snapshotType.includes('multiple markets') || snapshotType.includes('multimarket');
  }

  private shouldUseMetricAsCategory(data: any): boolean {
    const metricValues = data?.metric_value ?? [];
    if (metricValues.length > 1) {
      return true;
    }
    if (metricValues.length === 1) {
      const rowChildren = new Set(
        (metricValues[0].data ?? []).map((d: any) => d.rowChild).filter(Boolean)
      );
      return rowChildren.size > 1;
    }
    return false;
  }

  private shouldUseBrandAsCategory(data: any): boolean {
    if (this.isMultiMarketSnapshot) {
      return true;
    }
    if (!this._configService.selectedcompareacrossOption?.includes('Multiple Brands')) {
      return false;
    }
    return !this.shouldUseMetricAsCategory(data);
  }

  private resolveMetricDisplayName(lev2: any, dataArr: any): string {
    const raw = lev2?.option?.trim() || (dataArr?.rowChild ?? lev2?.rowChild ?? '');
    const value = typeof raw === 'string' ? raw.trim() : '';
    if (!value) return '';
    if (!value.includes('|')) return value;
    const parts = value.split('|').map((p: string) => p.trim());
    const last = parts[parts.length - 1]?.toLowerCase();
    if (last === 'yes') {
      if (parts.length >= 3) return `${parts[parts.length - 3]} | ${parts[parts.length - 2]}`;
      return parts[0] || '';
    }
    if (parts.length >= 2) return `${parts[parts.length - 2]} | ${parts[parts.length - 1]}`;
    return parts[0] || '';
  }

  private resolveBrandDisplayName(dataArr: any): string {
    if (dataArr.colChild) {
      const parts = dataArr.colChild.split('|');
      return parts.length > 1 ? parts[parts.length - 1].trim() : dataArr.colChild;
    }
    const match = dataArr.rowVariableCode?.match(/_(\d+)$/);
    if (!match) {
      return '';
    }
    const brandIndex = parseInt(match[1], 10) - 1;
    const sortedBrands = [...(this._configService.brandSortId || [])].sort(
      (a: any, b: any) => a.sortId - b.sortId
    );
    return sortedBrands[brandIndex]?.name ?? '';
  }

  private resolveMetricFilter(data: any, candidate: string): string {
    const filter = (candidate || '').trim();
    if (!filter || !this._configService.selectedcompareacrossOption?.includes('Multiple Brands')) {
      return '';
    }
    const options: string[] = (data?.metric_value || []).map((mv: any) => mv.option);
    if (options.includes(candidate)) {
      return candidate;
    }
    const normalizedFilter = filter.includes('|')
      ? filter.substring(filter.indexOf('|') + 1).trim()
      : filter;
    const match = options.find((opt: string) => opt?.trim() === normalizedFilter);
    return match || '';
  }

  private resolveSeriesName(dataArr: any, lev2: any, data: any): string {
    if (this.isAudienceSnapshot && this.shouldUseBrandAsCategory(data)) {
      return this.resolveBrandDisplayName(dataArr) || lev2.metric_group || '';
    }
    return lev2.metric_group || '';
  }

  preparemainChartData(data: any, metricFilter: string = '') {
    let i = 0;
    this.chartMainData = [];
    const isMultipleBrands = this._configService.selectedcompareacrossOption?.includes('Multiple Brands');
    const resolvedMetricFilter = this.resolveMetricFilter(data, metricFilter);
    const filteredMetricValue = (isMultipleBrands && resolvedMetricFilter)
      ? data.metric_value.filter((lev2: any) => lev2.option === resolvedMetricFilter)
      : data.metric_value;
    const result = this.transformRowChild(filteredMetricValue);
    const useMetricCategory = this.shouldUseMetricAsCategory({ metric_value: result });
    const useBrandCategory = this.shouldUseBrandAsCategory({ metric_value: result });
    const multipleMetricGroups = (result?.length ?? 0) > 1;

    result.forEach((lev2: any) => {
      let dataPoints = lev2.data ?? [];
      if (useMetricCategory && multipleMetricGroups) {
        dataPoints = dataPoints.length ? [dataPoints[0]] : [];
      }
      const hasPercentageExtension =
        lev2.extensionOptions?.some(
          (e: any) =>
            e.id === 'percentageSymbol' &&
            e.selected
        ) || null;
      dataPoints.forEach((dataArr: any) => {
        const categoryName = useBrandCategory
          ? (this.resolveBrandDisplayName(dataArr) || this.resolveMetricDisplayName(lev2, dataArr))
          : this.resolveMetricDisplayName(lev2, dataArr);
        let d1 = {
          "Series Name": this.resolveSeriesName(dataArr, lev2, { metric_value: result }),
          "Category Name": categoryName,
          "Rounded Value": dataArr.data == null ? null : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Value": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "ValueForIndex": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "ActualIndexValue": (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == null) ? null : (dataArr.CalculationTypeIndex?.toLowerCase() == "index" && dataArr.data2 == "NA" ? "NA" : dataArr.data2),
          "Label": dataArr.data == null ? "NA" : dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? dataArr.data * 100 : (dataArr.CalculationType?.toLowerCase() == "index" && dataArr.data == "NA" ? "NA" : dataArr.data),
          "Change value vs PY": dataArr.changeVsPY,
          "Significance": "-1",
          "Sample size": dataArr.baseValueforLSorIs,
          "Significance2": "1",
          "XValue": ++i,
          // "isPercentage": dataArr.CalculationType?.toLowerCase() == "share" || dataArr.CalculationType?.toLowerCase() == "respgrp" ? true : false,
          "isPercentage":
            (dataArr.CalculationType?.toLowerCase() === "share" ||
              dataArr.CalculationType?.toLowerCase() === "respgrp")
              ? true
              : (hasPercentageExtension === true ? false : hasPercentageExtension === null ? false : true),


          "Sig_LowerLimt": this.Sig_LowerLimt,
          "Sig_UpperLimt": this.Sig_UpperLimt,
          "Significance_Value": dataArr.Significance_Value,
          "color": dataArr.color,
          "colorLinearGradient": dataArr.colorLinearGradient
        }
        this.chartMainData.push(d1);
        if (!isNaN(d1["Rounded Value"])) {
          const rounded = Math.round(parseFloat(d1["Rounded Value"]) * 10) / 10;
          if (this.maxBarValue < rounded) {
            this.maxBarValue = rounded;
          }
        }
      });
    });
    if (this.configuredProperties) {
      if (this.configuredProperties?.sort == "ascending") {
        const sortedData = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in ascending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return 1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return -1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return a["Value"] - b["Value"];
        });
        this.chartMainData = sortedData;
      }
      if (this.configuredProperties?.sort == "descending") {
        const sortedDataDesc = this.chartMainData.sort((a: any, b: any) => {
          // Compare the "Value" field in descending order
          if (a["Value"] === "NA" && b["Value"] === "NA") {
            return 0; // If both are "NA", keep them in the same order
          }
          if (a["Value"] === "NA") {
            return -1; // If a is "NA", place it after b
          }
          if (b["Value"] === "NA") {
            return 1; // If b is "NA", place it after a
          }

          // Otherwise, compare numerically (assuming "Value" is a number or can be coerced into a number)
          return b["Value"] - a["Value"]; // For descending order, reverse the comparison
        });
        this.chartMainData = sortedDataDesc;
      }
    }

    // this.chartMainData=this.chartMainData.slice(0,1);
  }


  //parameters from snapshot-chrtparent
  @Input() popUp: any;
  @Input() customData: any;
  @Input() id: any = 0;
  @Input() sort: any;
  @Input() WidgetDetails: any;
  @Input() height: any = "24em";
  @Input() isOutput: any;

  getData(chartData: any, lowSample1: any) {
    if (this.isOutput) {
      // this.properties=this.configuredProperties!=undefined?this.configuredProperties:this.properties;
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;


      chartData[0].data = this.chartMainData
        .map((item: any, idx: number) => ({ ...item, XValue: idx + 1 }));

      if(chartData[0].data.length==0){        
        this.seriesData1 = [];
        return;
      }
      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name

      const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);


      //calculate the min and max value for the y-axis
      maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      this.max = maxValue + Math.ceil(maxValue * (this._configService.isRespondentLevel ? 0.10 : 0.20));
      this.min = minValue + Math.ceil(minValue * (this._configService.isRespondentLevel ? 0.10 : 0.20));
      //loop throught he filtered data
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

        //extract rounded value,if null plot as 0
        value: item['Value'] == null ? 0 : Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff),
        //if lowsample is selected,if rounded value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
        //name for each datapoint
        name: item['Category Name'],
         //apply pattern/gradient bar color or default color based on selection
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],  //this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? this.barService.linearGradients[i++] : this.barService.color1[i++],
        //color: this.categoryColorMap[item['Category Name']],
        visible: true,
        zIndex: 2,
        type: 'column',
        dataLabels: {

          borderWidth: 0,

        },
        data: [{
          name: item['Category Name'],
          seriesName: item['Series Name'],
          ispercent: item["isPercentage"],
          y: !Number.isFinite(parseFloat(item['Value'])) ? null : Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : Number(parseFloat(item['Value']).toFixed(this.properties.decimalRoundOff)) : 0)),
          //x value is used just to assign different colors for each bar
          x: parseInt(item['XValue']),
          indexValue: Number(item['Sample size']) <= this._configService.ISthreshold ? 0 : (!lowSample1 ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['ValueForIndex'] == null ? 0 : Number(parseFloat(item['ValueForIndex']).toFixed(this.properties.decimalRoundOff)) : 0)),
          actualIndexValue: item['ActualIndexValue'],
          dataLabels: {
            y: parseFloat(item['Value']) < 0 ? 14 : -28,
            verticalAlign: parseFloat(item['Value']) < 0 && this.properties.dataLabelPosition === 'top' ? 'bottom' : (parseFloat(item['Value']) < 0 && this.properties.dataLabelPosition === 'bottom' ? 'top' : this.properties.dataLabelPosition)
          }
        }],

        //extract changeVs value
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => (item["Change value vs PY"])),
        //extract significance value
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        //extract significance2 value
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        //extract sample size value
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        //extract rounded value
        roundedValue: indiaData.map((item: { [x: string]: string }) => Number.isFinite(parseFloat(item["Rounded Value"])) ? item["Rounded Value"] : null),
        //include tooltip to reflect the datalabel property selected
        tooltip: [],
        isPercentage: item["isPercentage"],
        Sig_LowerLimt: this.Sig_LowerLimt,
        Sig_UpperLimt: this.Sig_UpperLimt,
        Significance_Value: item["Significance_Value"],

      }));

      if (minValue >= 0)
        this.min = 0


      //extract category names
      this.categories = indiaData.map((item: { [x: string]: string }) => item['Category Name']);
      this.categories = [''].concat(indiaData.map((item: { [x: string]: string }) => item['Category Name']));

      //include additional series for marker
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        let markerStyle = this.properties.markerStyle;
        let offsetMultiplier = 0.03;
        // Change marker style to triangle if 'Rounded Value' is negative and marker style is 'triangle'
        if (parseFloat(item['Rounded Value']) < 0 && markerStyle === 'triangle') {
          markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
        }
        if (parseFloat(item['Rounded Value']) < 50 && parseFloat(item['Rounded Value']) > 0) {
          offsetMultiplier = 0.1; // Further increase offset if value is less than 50
        }
        if (parseFloat(item['Rounded Value']) <= 80 && parseFloat(item['Rounded Value']) >= 50 && parseFloat(item['Rounded Value']) > 0) {
          offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
        }
        this.seriesData1.push({
          name: item['Category Name'],
          type: 'scatter',
          zIndex: 1,
          marker: {
            symbol: markerStyle,
            fillColor: 'red',
            lineColor: 'red',
            lineWidth: 2,
          },
          enableMouseTracking: false,
          showInLegend: false,
          visible: this.properties.marker === 'enable',
          data: [{
            name: item['Category Name'],
            y: !lowSample1 ? (item['Rounded Value'] == null || parseFloat(item['Rounded Value']) === 0) ? null :
              parseFloat(item['Rounded Value']) > 0 ? parseFloat(item['Rounded Value']) + (offsetMultiplier * parseFloat(item['Rounded Value'])) :
                parseFloat(item['Rounded Value']) + (0.04 * parseFloat(item['Rounded Value'])) :
              (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant && item['Rounded Value'] != null && parseFloat(item['Rounded Value']) !== 0) ?
                parseFloat(item['Rounded Value']) > 0 ? parseFloat(item['Rounded Value']) + (0.03 * parseFloat(item['Rounded Value'])) :
                  parseFloat(item['Rounded Value']) + (0.05 * parseFloat(item['Rounded Value'])) : null,
            x: index + 1,
            z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ?
              0 :
              (item['Rounded Value'] != null ?
                parseFloat(item['Rounded Value']) :
                0),
            Sig_LowerLimt: this.Sig_LowerLimt,
            Sig_UpperLimt: this.Sig_UpperLimt,
            Significance_Value: item['Significance_Value']
          }],
        });
      });

    }
    else {
      let seriesData: any[] = [];
      let value = 0;
      let i = 0;
      let maxValue = 0;
      let minValue = 0;
      let j = -1;
      let finalValue = 0;
      //get the first series name
      const firstItem = chartData[0].data[0]['Series Name'];

      //get the category images
      this.categoryImages = chartData[0].data.map((item: { [x: string]: string }) => (item["Category Image"]));
      this.categoryImages = [''].concat(this.categoryImages);
      //extract all data matching the series name
      const indiaData = chartData[0].data.filter((item: { [x: string]: string }) => item['Series Name'] === firstItem);


      //calculate the min and max value for the y-axis
      maxValue = Math.max(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      minValue = Math.min(...indiaData.map((item: { [x: string]: string }) => parseFloat(item['Value']) || 0));
      this.max = maxValue + Math.ceil(maxValue * 0.10);
      this.min = minValue + Math.ceil(minValue * 0.10);
      //loop throught he filtered data
      this.seriesData1 = indiaData.map((item: { [x: string]: string }) => ({

        //extract Value,if null plot as 0
        value: item['Value'] == null ? 0 : parseFloat(item['Value']),
        //if lowsample is selected,if Value extract has sampl size greater than the threshold(this.barService.sampleSizeConstant) plot as 0
        numericValue: !lowSample1 ? value : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? value : 0),
        //name for each datapoint
        name: item['Category Name'],

        //apply pattern/gradient bar color or default color based on selection
        color: this.properties.showPattern ? this.getPatternForImage(this.barService.patternImages[i++]) : this.properties.gradientBarColor ? item['colorLinearGradient'] : item['color'],

        visible: true,
        zIndex: 2,
        type: 'column',
        dataLabels: {

          borderWidth: 0,

        },
        data: [{
          name: item['Category Name'],
          seriesName: item['Series Name'],
          y: !lowSample1 ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant ? item['Value'] == null ? 0 : parseFloat(Number(item["Value"]).toFixed(this.properties.decimalRoundOff)) : 0),
          //x value is used just to assign different colors for each bar
          x: parseInt(item['XValue']),
          dataLabels: {
            y: parseFloat(item['Value']) < 0 ? 0 : -28,
            verticalAlign: parseFloat(item['Value']) < 0 && this.properties.dataLabelPosition === 'top' ? 'bottom' : (parseFloat(item['Value']) < 0 && this.properties.dataLabelPosition === 'bottom' ? 'top' : this.properties.dataLabelPosition)
          }
        }],

        //extract changeVs value
        changeValueSeries: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Change value vs PY"])),
        //extract significance value
        significance: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance"])),
        //extract significance2 value
        significance2: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Significance2"])),
        //extract sample size value
        sampleSize: indiaData.map((item: { [x: string]: string }) => parseFloat(item["Sample size"])),
        //extract Value
        roundedValue: indiaData.map((item: { [x: string]: string }) => item["Value"]),
        //include tooltip to reflect the datalabel property selected
        tooltip: [],


      }));


      //extract category names
      this.categories = indiaData.map((item: { [x: string]: string }) => item['Category Name']);
      this.categories = [''].concat(indiaData.map((item: { [x: string]: string }) => item['Category Name']));

      //include additional series for marker
      indiaData.forEach((item: { [x: string]: string }, index: number) => {
        let markerStyle = this.properties.markerStyle;
        let offsetMultiplier = 0.03;
        // Change marker style to triangle if 'Value' is negative and marker style is 'triangle'
        if (parseFloat(item['Value']) < 0 && markerStyle === 'triangle') {
          markerStyle = 'triangle-down'; // Or whatever style you want to use for negative values
        }
        if (parseFloat(item['Value']) < 50 && parseFloat(item['Value']) > 0) {
          offsetMultiplier = 0.1; // Further increase offset if value is less than 50
        }
        if (parseFloat(item['Value']) <= 80 && parseFloat(item['Value']) >= 50 && parseFloat(item['Value']) > 0) {
          offsetMultiplier = 0.04; // Increase offset if value is less than or equal to 80 and greater than 0
        }
        this.seriesData1.push({
          name: item['Category Name'],
          type: 'scatter',
          zIndex: 1,
          marker: {
            symbol: markerStyle,
            fillColor: 'red',
            lineColor: 'red',
            lineWidth: 2,
          },
          enableMouseTracking: false,
          showInLegend: false,
          visible: this.properties.marker === 'enable',
          data: [{
            name: item['Category Name'],
            y: !lowSample1 ? (item['Value'] == null || parseFloat(item['Value']) === 0) ? null :
              parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (offsetMultiplier * parseFloat(item['Value'])) :
                parseFloat(item['Value']) + (0.04 * parseFloat(item['Value'])) :
              (parseFloat(item['Sample size']) > this.barService.sampleSizeConstant && item['Value'] != null && parseFloat(item['Value']) !== 0) ?
                parseFloat(item['Value']) > 0 ? parseFloat(item['Value']) + (0.03 * parseFloat(item['Value'])) :
                  parseFloat(item['Value']) + (0.05 * parseFloat(item['Value'])) : null,
            x: index + 1,
            z: parseFloat(item['Sample Size']) > this.barService.sampleSizeConstant ?
              0 :
              (item['Value'] != null ?
                parseFloat(item['Value']) :
                0),
          }],
        });
      });



    }
  }
  patternselect(ispattern: boolean) {
    //apply pattern to bar
    this.properties.showPattern = ispattern
    this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
    this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
  }
  getColor(): string {
    //apply gradient color
    const color = this.barService.colors[this.barService.colorIndex];
    this.barService.colorIndex = (this.barService.colorIndex + 1) % this.barService.colors.length; // Cycle through colors
    return color;
  }




  // commonfunc(event: any, customization: string, options: any) {
  //   let property;
  //   this.event = event;
  //   //choose the appropriate customization
  //   this.barService.commonFunc(customization, event, this.properties)
  //   this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
  //   this.getBarChart('chart-container'+this.id, this.seriesData1, this.properties);
  // }
  getBarChart(containerId: string, seriesData: any[], properties: any) {
    if (this.isOutput) {
      if (!seriesData || seriesData.length === 0) {
        const containerEl = document.getElementById(containerId);
        if (containerEl) {
          containerEl.innerHTML = '<div style="display:flex; align-items:center; justify-content:center; height:100%; min-height:100px; font-size: 0.7rem; font-family:KantarBrown-Regular,sans-serif;">Not Applicable</div>';
        }
        return;
      }
      let popUp = this.popUp;
      localStorage.setItem("properties", JSON.stringify(this.properties));
      let serviceBar = this.barService;
      let i = 0;
      const updatedCategories1 = this.categoryImages;
      const defaultCategories = this.categories;

      const screenHeight = window.innerHeight; // Get the screen width
      let xAxisyLabelPosition;

      let height = '48%';
      if (screenHeight <= 610) { //for 150% -> 593
        // xAxisyLabelPosition = this.popUp ? 50 : 30;
        xAxisyLabelPosition = this.popUp ? 50 : 50;
      } else if (screenHeight <= 800) { //for 125% -> 738

        // xAxisyLabelPosition = this.popUp ? 40 : 5;
        xAxisyLabelPosition = this.popUp ? 40 : 5;

      } else if (screenHeight <= 1200) { //for 100%
        xAxisyLabelPosition = this.popUp ? 95 : 15;
        height = '40%';
      }

      const configService = this._configService;
      this.properties = this.configuredProperties != undefined ? this.configuredProperties : this.properties;
      this.properties.showLegend = false;
      properties = this.properties
      let maxLabelCharacters = popUp ? 13 : 10;

      // Compute yAxis min from actual plotted y values to support negative bars
      const yValues: number[] = seriesData
  .filter((s: any) => s.type === 'column')
  .flatMap((s: any) => s.data.map((d: any) => d.y))
  .filter((v: any) => v !== null && v !== undefined && !isNaN(v));
const computedMin = yValues.length > 0 ? Math.min(...yValues) : 0;
const computedMax = yValues.length > 0 ? Math.max(...yValues) : 0;
const yAxisMin = computedMin < 0 ? computedMin * 2 : 0;

      const options: Highcharts.Options = {
        chart: {
          type: 'column',
          reflow: true,
          // height: height,
         // marginBottom: yAxisMin < 0 ? 80 : (defaultCategories.length > (this.maxDataPoints + 1) ? 40 : undefined),
         marginBottom: defaultCategories.length > (this.maxDataPoints + 1) ? 55 : (yAxisMin < 0 ? 40 : undefined),

          //apply background color and text color based on light or dark theme
          backgroundColor: this.properties.darkTheme ? this.barService.darkThemeBackgroundColor : this.barService.defaultThemeBackgroundColor,
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            // height: this.height != '22em' ? 262 : 450,
            // height:'95%',
            fontSize: '0.7rem',
            overflow: 'visible',
            zIndex: 2
          },
          events: {
            //to hide the marker along with the bar,when legend is click for each bar
            redraw: function (this: any) {
              // Adjust scatter series position after redrawing the chart
              var chart = this,
                series = chart.series;

              series.forEach(function (ser: any) {
                if (ser.type === 'column' && ser.type == 'scatter') {

                  ser[1].forEach(function (scatter: any) {
                    scatter.setVisible(ser.visible, false);
                  });
                }
              });
            },
            load: function () {
              const chart = this;
              // window.addEventListener('resize', function () {
              //   chart.reflow();
              // });
              serviceBar.enableWheelScroll(chart);
            }
          }
        },
        title: {
          //add title styles :position and color options
          // text: this.data.title,
          text: '',
          align: this.properties.chartTitlePosition,
          style: {
            color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
            marginleft: '4%',
            fontSize: '1em',
            fontFamily: this.barService.textfont
          },
        },
        subtitle: {
        },
        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false
        },
        //legend position
        legend: this.barService.customizeLegend(this.chart, this.properties.showLegend, this.properties.legendPosition, this.properties, this.height, popUp), // Semicolon added

        xAxis: {
          lineColor: '#A2A2A2', // Change to desired axis line color
          lineWidth: 1,
          categories: defaultCategories,
          gridLineWidth: this.properties.xaxisgridlines ? 1 : 0,
          //shows 10 bars in each slide
          min: 1,
          max: Math.max(1, this.visibleCategoryCount),
          //if number of bars are greater than 10,scrollbar is seen
          //scrollbar styles
          scrollbar: {
            enabled: false,
            height: 10,
            barBackgroundColor: '#0060FF',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: '#0060FF',
            buttonBackgroundColor: this.properties.darkTheme ? '#555555' : '#E5E5E5',
            buttonBorderWidth: 0,
            buttonArrowColor: this.properties.darkTheme ? '#FFFFFF' : '#404040',
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.properties.darkTheme ? '#3A3A3A' : '#E5E5E5',
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5,
            margin: 20
          },
          showEmpty: false,
     labels: {
  //x-axis labels styles
  useHTML: true,
  // y: xAxisyLabelPosition,
  style: {
    fontFamily: this.barService.textfont,
    color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
    whiteSpace: 'normal',
    textOverflow: 'unset',
  },
  formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
    // Calculate available width per label
    const chart = this.axis.chart;
    const categories = this.axis.categories || [];
    const chartWidth = chart.plotWidth || 400;
    const numCategories = Math.max(categories.length - 1, 1); // Exclude first empty category
    
    // Calculate base width per category with enhanced popup support
    const baseWidth = Math.floor(chartWidth / numCategories);
    const padding = popUp ? 15 : 8; // Reduced padding for popup to utilize more space
    const minWidth = popUp ? 120 : 80; // Higher minimum width for popups
    const labelWidth = Math.max(baseWidth - padding, minWidth);

    // Split label into max 2 lines, not breaking words
    function splitLabelToTwoLines(str: string, maxWidth: number) {
      // Estimate average character width (in px) - adjusted for better accuracy
      const avgCharWidth = popUp ? 6.0 : 6.5; // Slightly smaller char width for popup to fit more text
      const maxCharsPerLine = Math.floor(maxWidth / avgCharWidth);

      const words = str.split(' ');
      let line1 = '';
      let line2 = '';
      let currentLine = '';
      let breakIndex = 0;

      // Build first line
      for (let i = 0; i < words.length; i++) {
        const testLine = currentLine ? currentLine + ' ' + words[i] : words[i];
        if (testLine.length <= maxCharsPerLine || !currentLine) {
          currentLine = testLine;
          breakIndex = i + 1;
        } else {
          break;
        }
      }
      line1 = currentLine;

      // Build second line with remaining words
      const remainingWords = words.slice(breakIndex);
      line2 = remainingWords.join(' ');

      // Truncate second line with ellipsis if needed
      if (line2.length > maxCharsPerLine) {
        line2 = line2.substring(0, maxCharsPerLine - 3).trim() + '...';
      }

      return line2 ? `${line1}<br/>${line2}` : line1;
    }

    let labelContent = String(this.value);
    labelContent = splitLabelToTwoLines(labelContent, labelWidth);

    // Determine text alignment based on number of lines
    const isMultiLine = labelContent.includes('<br/>');
    const textAlign = 'center';

    // If axisImage is enabled, show image instead
    if (properties.axisImage) {
      let index = categories.indexOf(String(this.value));
      const category1 = serviceBar.baseImgPath + updatedCategories1[index] + '.png';
      if (category1) {
        return `<span style="display: inline-block; width: 2em; height: 2em; background: url(${category1}) no-repeat center center; background-size: cover;"></span>`;
      } else {
        return '<span>No Image</span>';
      }
    } else {
      // Center-align text for single line, left-align for multiple lines
      const marginStyle = popUp ? 'margin: 0 2px' : 'margin: 0 auto';
      return `<div style="width:${labelWidth}px; text-align: ${textAlign}; ${marginStyle}; padding: 0;" title="${String(this.value)}">${labelContent}</div>`;
    }
  },
  rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation),
},
        },
        yAxis: {
          //min and max for y-axis
            max: computedMax * 1.15, 
          min: yAxisMin,
          plotLines: [{
            value: 0,
            width: 1
          }],
          tickInterval: this.getTickInterval(this.maxBarValue),
          //gridlines visibility
          gridLineWidth: this.properties.yaxisgridlines ? 1 : 0,
          //y-axis labels styles
          labels: {
            enabled: false,
            format: this.properties.datalabelFormat == "percentage" ? '{value}%' : '{value}',
            style: {
              color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
              fontFamily: this.barService.textfont,
            },
          },
          title: {
            text: '', // Set an empty string to hide the yAxis title
          },
        },
        //tooltip styles
             tooltip: {
        enabled: true,
        borderWidth: 1,
        useHTML: true,
       
        shadow: false,
        

        formatter: function (this: any) {
          //disable tootltip for marker
          if (this.series.name === 'Marker1') return false;
          //select tooltip style
          let isDefaultTooltip = properties.toolTipStyle;
          //tooltip border color
          const dotColor = this.color// Get the series color
          const backgroundcolor = properties.darkTheme ? '#f5f5f5' : '#b3b3b3';
          const backgroundcolor2 = properties.darkTheme ? 'white' : '#ddddd';
          //get the appropriate tooltip according to datalabel property selected
          const text = properties.showDataLabel ? this.series.userOptions.tooltip[this.point.x - 1] : this.y;

        if (isDefaultTooltip == 'style1') {
          const content =
            `<div style="background: transparent; border: none; border-radius: 8px; min-width: 50px; font-size: 1.1em; display: flex; align-items: center; ">
      <span style="display:inline-block; width:10px; height:10px; border-radius:50%; background:${dotColor}; margin-right:8px; vertical-align:middle;"></span>
      <span>${this.point.name}: </span>
      <b style="margin-left:4px;">${text}</b>
    </div>`;
  return content;

          
          }
      else {
    const commonContent =
              `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
             
              `<span><strong>Category Name:</strong></span> ${this.point.name}<br>` +
              `<span><strong>Value:</strong></span> ${text}`;



            return commonContent + '</div>';
}




        },
      },

        plotOptions: {
          series: {
            borderWidth: 0,
            animation: false,
            allowPointSelect: false,
            states: {
              hover: {
                enabled: false
              },
              inactive: {
                enabled: false
              },
              select: {
                enabled: false
              }
            },
            //animation is set to off for datalabeposition* as it is applicable only for aspose side
            // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
            events: {
              //when a legend is clicked fro the bar,bar must disappear
              legendItemClick: function (this: any) {
                var series = this.chart.series,
                  selectedSeriesName = this.name;

                // Loop through all series
                for (var i = 0; i < series.length; i++) {
                  // Check if the series name matches the clicked legend's series name
                  if (series[i].name === selectedSeriesName) {
                    // Toggle visibility of both bar and scatter series
                    series[i].setVisible(!series[i].visible, false);
                    if (series[i].type == 'scatter') {
                      series[i].scatterSeries.setVisible(!series[i].visible, false);
                    }
                  }
                }

                // Redraw the chart
                this.chart.redraw();

                // Prevent default legend item click action
                return false;
              }
            }
          },
          column: {
            //plotting styles

            //distance between bars
            pointPadding: 2,
            groupPadding: 3,
            grouping: false,
            stacking: undefined,
            //shadow styles
            shadow: this.properties.shadow ? {
              color: this.barService.shadowColor,
              offsetX: 1,
              offsetY: 1,
              opacity: 0.5,
              width: 6,
            } : false,
            //bar size
            pointWidth: 25,
            //datalabel styles
            dataLabels: {

              style: {

                backgroundColor: this.barService.transparentBackground,
                //datalabel border
                textOutline: 'none',
                //datalabel color
                color: this.properties.darkTheme ? (this.properties.dataLabelColor === 'default' ? 'white' : this.properties.dataLabelColor || this.barService.darkThemeTextColor)
                  : (this.properties.dataLabelColor === 'default'
                    ? 'black'
                    : this.properties.dataLabelColor || this.barService.defaultThemeTextColor),
                //datalabel font size
                fontSize: this.properties.dataLabelSize,
                fontWeight: "normal",
                fontFamily: this.barService.textfont

              },

              overflow: 'allow',
              crop: false,
              //enable the datalabel based on selection
              enabled: this.properties.showDataLabel,
              //datalabel is shown inside the bar
              inside: false,


              //datalabel alignment
              align: 'center',
              //datalabel overlap is set to true by default
              allowOverlap: true,
              //datalabel position
              verticalAlign: this.properties.dataLabelPosition,
              x:0,
               y: -28,
              
              // x: this.properties.dataLabel_x_position,
              formatter: function (this: any) {
                if (properties.datalabelStyle == "index") {
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSize[this.point.x - 1],);

                  this.series.userOptions.tooltip[this.point.x - 1] = text;

                  // let text2 = this.series.userOptions.roundedValue[this.point.x - 1] === 0
                  //   ? serviceBar.nullValueText
                  //   : this.series.userOptions.roundedValue[this.point.x - 1] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.point.indexValue : serviceBar.nullValueText;

                  let text2 = this.point.actualIndexValue == null
                    ? serviceBar.nullValueText
                    : this.series.userOptions.roundedValue[this.point.x - 1] == -1 ? -1 : this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.point.indexValue : serviceBar.nullValueText;

                  if (text2 == "-1" || text2 == -1) {
                    text2 = "NA";
                  }
                  text2 = configService.CheckLSorIScondition(configService.userRole, text2, this.series.userOptions.sampleSize[this.point.x - 1],);
                  let color = configService.CheckIndexColoring(text2);

                  this.series.userOptions.tooltip[this.point.x - 1] = text + "(" + text2 + ")";;
                  return (
                    '<span style="font-size:0.5rem;">' + text + '</span><br>' + " " + '(' +
                    '<span style="color:' + color + ';font-size:0.5rem;">' + text2 + ')</span>'
                  );
                }

                if (properties.datalabelStyle == "sigChange") {
                  //extract each changeVs value
                  let changeText = this.series.userOptions.isPercentage ? (this.series.userOptions.changeValueSeries[this.point.x - 1]) * 100 :
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let textCheck = configService.CheckLSorIScondition(configService.userRole, this.y, this.series.userOptions.sampleSize[this.point.x - 1]);
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? textCheck + (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '') : serviceBar.nullValueText;
                  // text = textCheck+ (this.series.userOptions.isPercentage && (textCheck != 'I/S') ? '%' : '');
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? 'green' : sig < 0 ? 'red' : '';
                  //include + if changeValue is positive
                  // if (parseFloat(changeText) > 0) {
                  //   changeText = "+" + changeText;
                  // }
                  let sigClass = this.series.userOptions.Significance_Value < this.series.userOptions.Sig_LowerLimt ? 'red' : this.series.userOptions.Significance_Value > this.series.userOptions.Sig_UpperLimt ? 'green' : 'black';
                  //merge text+changeText+significance
                  if (this.series.userOptions.changeValueSeries[this.point.x - 1] == null || this.series.userOptions.changeValueSeries[this.point.x - 1] == 'NA') {
                    let finalText = '<span>' +
                      '<span>' + text + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x - 1] != null && textCheck != 'I/S' ? '<span>&nbsp<br>' +
                        '<br><span style="color:black; font-size: 80%;margin-left:3px;  ">(NA)</span>&nbsp;' +
                        '</span>' : '') +
                      '</span>';

                    let tooltipText = '<span>' +
                      '<span>' + text + '</span>' +
                      (this.series.userOptions.roundedValue[this.point.x - 1] != null && textCheck != 'I/S' ? '<span>&nbsp' +
                        '<span style="color:black; font-size: 80%;margin-left:3px;  ">(NA)</span>&nbsp;' +
                        '</span>' : '') +
                      '</span>';
                    //assign the finalText to tooltip
                    this.series.userOptions.tooltip[this.point.x - 1] = tooltipText;
                    //return the finalText
                    return (
                      finalText
                    );
                  }
                  else {
                    let finalText = '<span>' +
                      '<span>' + text + '</span>' +

                      (this.series.userOptions.Significance_Value == 0 ?
                        '<br><span style="color:' + sigClass + '; font-size: 80%;margin-left:3px;  ">(' + (this.series.userOptions.Significance_Value + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>'
                        :
                      (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText != null && textCheck != 'I/S' ? '<span>&nbsp<br>' +
                        '<span style="color:' + sigClass + '; font-size: 80%;margin-left:3px;  ">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>' : '')) +
                      '</span>' ;

                    let tooltipText = '<span>' +
                      '<span>' + text + '</span>' +

                      (this.series.userOptions.Significance_Value == 0 ?
                        '<br><span style="color:' + sigClass + '; font-size: 80%;margin-left:3px;  ">(' + (0 + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>'
                        :
                      (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText && textCheck != 'I/S' ? '<span>&nbsp' +
                        '<span style="color:' + sigClass + '; font-size: 80%;margin-left:3px;  ">(' + (parseFloat(Number(changeText).toFixed(1)) + (this.series.userOptions.isPercentage ? '%' : '')) + ')</span>&nbsp;' +
                        '</span>' : '')) +
                      '</span>';
                    //assign the finalText to tooltip
                    this.series.userOptions.tooltip[this.point.x - 1] = tooltipText;
                    //return the finalText
                    return (
                      finalText
                    );
                  }
                }

                //significance and changeVs option is selected from datalabel property
                if (properties.datalabelStyle == "significance + changeVs") {
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  //extract each changeVs value
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                  //extarct each signififcance value
                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  //set the significance arrow according to its value
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  //assign color to the arrow
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  //include + if changeValue is positive
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  //merge text+changeText+significance
                  let finalText = '<span>' +
                    '<span>' + text + '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '<span style="color:' + sigcolor + ';">' + s + '</span>' : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  //return the finalText
                  return (
                    finalText
                  );


                }
                if (properties.datalabelStyle == "change") {

                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text + "  " +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText ? '<span>&nbsp' +
                      '<span style="font-size: ' + serviceBar.changeValueFontSize + ';color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + '; ">(' + changeText + ')</span>&nbsp;' +
                      '</span>' : '');
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return (
                    finalText
                  );

                }

                if (properties.datalabelStyle == "ls") {


                  let text = parseFloat(this.series.userOptions.sampleSize[this.point.x - 1]) > serviceBar.sampleSizeConstant ? this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText : serviceBar.lowSampleText;
                  let finalText = '<b>' +
                    text +
                    '</b> ' +
                    '<span style="opacity: 0.5"></span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                }
                if (properties.datalabelStyle == "significance") {
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let sigcolor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let finalText = '<span >' + text + (this.series.userOptions.roundedValue[this.point.x - 1] != null ? '&nbsp<span style="color:' + sigcolor + ';">' + s + '</span>' : '') + '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return (
                    finalText
                  )

                }
                if (properties.datalabelStyle == "default") {

                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (this.series.data[0].ispercent ? '%' : '') : serviceBar.nullValueText;

                  text = configService.CheckLSorIScondition(configService.userRole, text, this.series.userOptions.sampleSize[this.point.x - 1],);

                  this.series.userOptions.tooltip[this.point.x - 1] = text;

                  return (
                    '<span >' + text + '</span>'
                  );
                }
                if (properties.datalabelStyle == "datalabel") {

                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  this.series.userOptions.tooltip[this.point.x - 1] = text;
                  return (
                    '<span >' + text + '</span>'
                  );
                }

                if (properties.datalabelStyle == "significance2") {
                  let text = this.series.userOptions.roundedValue[this.point.x - 1] != null ? this.y + (properties.datalabelFormat == "percentage" ? '%' : '') : serviceBar.nullValueText;
                  let changeText = this.series.userOptions.changeValueSeries[this.point.x - 1];
                  let sig = this.series.userOptions.significance[this.point.x - 1];
                  let sig1 = this.series.userOptions.significance2[this.point.x - 1];
                  let sColor = sig > 0 ? serviceBar.highSignificance : (sig < 0 ? serviceBar.lowSignificance : '');
                  let s = sig > 0 ? serviceBar.upwardTriangle : (sig < 0 ? serviceBar.downwardTriangle : '');
                  let changeColor = sig1 < 0 ? serviceBar.lowSignificance : (sig1 > 0 ? serviceBar.highSignificance : properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor);


                  if (parseFloat(changeText) > 0) {
                    changeText = "+" + changeText;
                  }
                  let finalText = '<span>' + text +
                    (this.series.userOptions.roundedValue[this.point.x - 1] != null && changeText ? '&nbsp<span style="color:' + (properties.darkTheme ? serviceBar.darkThemeTextColor : serviceBar.defaultThemeTextColor) + ' "> ' +
                      '<span style="font-size:' + serviceBar.changeValueFontSize + '; color:' + changeColor + ';">(' + changeText + ')</span>&nbsp' +
                      '<span style="color:' + sColor + ';">' + s + '</span>' : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return (
                    finalText
                  );
                }


                return !Number.isNaN(this.series.userOptions.roundedValue[this.point.x - 1]) ? this.y : 'NA';

              },
            },
          },
        },
        series: this.properties.top10 ? seriesData.splice(0, 10) : seriesData,
      }
      const containerEl = document.getElementById('chart-container' + this.id);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, options);
    }
    else {
      localStorage.setItem("properties", JSON.stringify(this.properties));
      this.getData(this.jsonData, this.properties.datalabelStyle == "ls");
      let serviceBar = this.barService;

      let i = 0;
      const screenHeight = window.innerHeight; // Get the screen width
      let xAxisyLabelPosition;

      // let height = '48%';
      // if (screenHeight <= 610) { //for 150% -> 593
      //   xAxisyLabelPosition = this.popUp ? 50 : 30;
      // } else if (screenHeight <= 800) { //for 125% -> 738

      //   xAxisyLabelPosition = this.popUp ? 40 : 5;
      // } else if (screenHeight <= 1200) { //for 100%
      //   xAxisyLabelPosition = this.popUp ? 95 : 15;
      //   height = '40%';
      // }


      const updatedCategories1 = this.categoryImages;
      const defaultCategories = this.categories;

      const containerEl = document.getElementById('chart-container' + this.id);
      if (!containerEl) { return; }
      this.chart = Highcharts.chart(containerEl, {
        chart: {
          type: 'column',
          //apply background color and text color based on light or dark theme
          backgroundColor: this.properties.darkTheme
            ? this.barService.darkThemeBackgroundColor
            : this.barService.defaultThemeBackgroundColor,
          style: {
            fontFamily: this.barService.textfont,
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
          },
          events: {
            //to hide the marker along with the bar,when legend is click for each bar
            redraw: function (this: any) {
              // Adjust scatter series position after redrawing the chart
              var chart = this,
                series = chart.series;

              series.forEach(function (ser: any) {
                if (ser.type === 'column' && ser.type == 'scatter') {
                  ser[1].forEach(function (scatter: any) {
                    scatter.setVisible(ser.visible, false);
                  });
                }
              });
            },
            load: function () {
              const chart = this;
              // window.addEventListener('resize', function () {
              //   chart.reflow();
              // });
              serviceBar.enableWheelScroll(chart);
            },
          },
        },

        title: {
          //add title styles :position and color options
          text: '',
          align: this.properties.chartTitlePosition,
          style: {
            color: this.properties.darkTheme
              ? this.barService.darkThemeTextColor
              : this.barService.defaultThemeTextColor,
            marginleft: '4%',
            fontSize: '2em',
            fontFamily: this.barService.textfont,
          },
        },
        subtitle: {},

        exporting: {
          enabled: false,
        },
        credits: {
          enabled: false,
        },
        //legend position
        //legend: this.barService.customizeLegend(this.chart, this.properties.showLegend, this.properties.legendPosition, this.properties,this.height), // Semicolon added
        legend: {
          enabled: false,
        },

        xAxis: {
          categories: defaultCategories,
          //shows 10 bars in each slide
          min: 1,
          max: Math.max(1, this.visibleCategoryCount),
          //if number of bars are greater than 10,scrollbar is seen
          //scrollbar styles
          scrollbar: {
            enabled: false,
            height: 10,
            barBackgroundColor: '#0060FF',
            barBorderRadius: 5,
            barBorderWidth: 0,
            barBorderColor: '#0060FF',
            buttonBackgroundColor: this.properties.darkTheme ? '#555555' : '#E5E5E5',
            buttonBorderWidth: 0,
            buttonArrowColor: this.properties.darkTheme ? '#FFFFFF' : '#404040',
            buttonBorderRadius: 5,
            rifleColor: 'none',
            trackBackgroundColor: this.properties.darkTheme ? '#3A3A3A' : '#E5E5E5',
            trackBorderWidth: 0,
            trackBorderColor: 'black',
            trackBorderRadius: 5,
          },
          showEmpty: false,
          // labels: {
          //   //x-axis labels styles
          //   useHTML: true,
          //   style: {
          //     fontFamily: this.barService.textfont,
          //     color: this.properties.darkTheme ? this.barService.darkThemeTextColor : this.barService.defaultThemeTextColor,
          //   },
          //   formatter: function (this: Highcharts.AxisLabelsFormatterContextObject) {
          //     //x-axis images are added
          //     if (properties.axisImage) {
          //       let index = defaultCategories.indexOf(String(this.value));
          //       let i = 0;

          //       const category1 = serviceBar.baseImgPath + updatedCategories1[index] + '.png'
          //       if (category1) {
          //         return '<span style="display: inline-block; width: 2em; height: 2em; background: url(' + category1 + ') no-repeat center center; background-size: cover;"></span>';
          //       } else {
          //         return '<span>No Image</span>';
          //       }
          //     } else {
          //       return String(this.value);
          //     }
          //   },

          //   //axis label orientation
          //   rotation: this.barService.axisLabelOrientation(this.properties.axisLabelOrientation), // Rotate labels by -90 degrees (or any other desired angle)
          // }
          labels: {
            //x-axis labels styles
            useHTML: true,
            y: xAxisyLabelPosition,
            style: {
              fontFamily: this.barService.textfont,
              color: this.properties.darkTheme
                ? this.barService.darkThemeTextColor
                : this.barService.defaultThemeTextColor,
              fontSize: '0.7rem',
            },
            formatter: function (
              this: Highcharts.AxisLabelsFormatterContextObject
            ) {
              //x-axis images are added
              if (properties.axisImage) {
                let index = defaultCategories.indexOf(String(this.value));
                let i = 0;

                const category1 =
                  serviceBar.baseImgPath + updatedCategories1[index] + '.png';
                if (category1) {
                  return (
                    '<span style="display: inline-block; width: 2em; height: 2em; background: url(' +
                    category1 +
                    ') no-repeat center center; background-size: cover;"></span>'
                  );
                } else {
                  return '<span>No Image</span>';
                }
              } else {
                return `<div style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding: 0% 4%;" title="${String(
                  this.value
                )}">${String(this.value)}</div>`;
              }
            },

            //axis label orientation
            rotation: this.barService.axisLabelOrientation(
              this.properties.axisLabelOrientation
            ), // Rotate labels by -90 degrees (or any other desired angle)
          },
        },
        yAxis: {
          //min and max for y-axis
          enabled: false,
          max: this.max,
          min: this.min,
          plotLines: [
            {
              value: 0,
              width: 1,
            },
          ],
          tickInterval: 50,
          //gridlines visibility
          gridLineWidth: this.properties.gridlines ? 1 : 0,

          //y-axis labels styles
          labels: {
            enabled: false,
            format:
              this.properties.datalabelFormat == 'percentage'
                ? '{value}%'
                : '{value}',
            style: {
              color: this.properties.darkTheme
                ? this.barService.darkThemeTextColor
                : this.barService.defaultThemeTextColor,
              fontFamily: this.barService.textfont,
            },
          },
          title: {
            text: '', // Set an empty string to hide the yAxis title
          },
        },
        //tooltip styles
        tooltip: {
          enabled: true,
          borderWidth: 0,
          useHTML: true,
          shape: properties.toolTipStyle == 'style1' ? 'square' : 'callout',
          shadow: false,
          backgroundColor: 'rgba(0,0,0,0)',

          formatter: function (this: any) {
            //disable tootltip for marker
            if (this.series.name === 'Marker1') return false;
            //select tooltip style
            let isDefaultTooltip = properties.toolTipStyle;
            //tooltip border color
            //const dotColor = serviceBar.colors[this.point.x - 1]; // Get the series color
            const dotColor = this.color;
            const backgroundcolor = properties.darkTheme
              ? '#b3b3b3'
              : '#f5f5f5';
            const backgroundcolor2 = properties.darkTheme ? '#dddddd' : 'white';
            //get the appropriate tooltip according to datalabel property selected
            const text = properties.showDataLabel
              ? this.series.userOptions.tooltip[this.point.x - 1]
              : this.y;

            if (isDefaultTooltip == 'style1') {
              // const commonContent =
              //   `<div style="border-left: 5px solid ${dotColor}; border-bottom: 5px solid ${dotColor}; z-index: 100; padding: 2%; border-radius: 5px; margin: 0; background-color :${backgroundcolor2};">` +
              //   `<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
              //   `<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
              //   `<span><strong>Category Name:</strong></span> ${this.point.name}<br>` +
              //   `<span><strong>Value:</strong></span> ${text}`;

              // return commonContent + '</div>';
              const commonContent =
                `<div style="border-left: 2px solid ${dotColor}; border-bottom: 2px solid ${dotColor};width:fit-content; z-index: 100; padding: 2%; border-radius: 5px; margin: 0;font-size: 1.1em; background-color :${backgroundcolor2};">` +
                //`<span style="display: block; text-align: center; color: ${dotColor}; font-weight: bold; font-size: 0.8rem;">Tooltip Title</span>` +
                //`<span><strong>Series Name:</strong></span> ${this.point.seriesName}<br>` +
                `${this.point.name}: ` +
                `${text}`;
              return commonContent + '</div>';
            } else {
              const content =
                `<div style="background-color: ${backgroundcolor}; padding: 10%; align-items: center; border: 1px solid ${dotColor}; width:120%">` +
                `<div style="width: 1em; height: 1em; background-color: ${dotColor}; border-radius: 50%; margin-right: 5%;"> </div>` +
                ` ${this.series.name}` +
                `<div style="display: block; margin-top: 1%;"><strong>Value:</strong> ${text}</div>`;

              return content + '</div>';
            }
          },
        },

        plotOptions: {
          series: {
            borderWidth: 0,
            animation: false,
            //animation is set to off for datalabeposition* as it is applicable only for aspose side
            // animation: this.properties.dataLabelPositionPPT == 'Inside Base' || this.properties.dataLabelPositionPPT == 'Center' || this.properties.dataLabelPositionPPT == 'Inside End' || this.properties.dataLabelPositionPPT == 'Outside End' ? false : true,
            events: {
              //when a legend is clicked fro the bar,bar must disappear
              legendItemClick: function (this: any) {
                var series = this.chart.series,
                  selectedSeriesName = this.name;

                // Loop through all series
                for (var i = 0; i < series.length; i++) {
                  // Check if the series name matches the clicked legend's series name
                  if (series[i].name === selectedSeriesName) {
                    // Toggle visibility of both bar and scatter series
                    series[i].setVisible(!series[i].visible, false);
                    if (series[i].type == 'scatter') {
                      series[i].scatterSeries.setVisible(
                        !series[i].visible,
                        false
                      );
                    }
                  }
                }

                // Redraw the chart
                this.chart.redraw();

                // Prevent default legend item click action
                return false;
              },
            },
          },
          column: {
            //plotting styles

            //distance between bars
            pointPadding: 2,
            groupPadding: 3,
            grouping: false,
            stacking: undefined,
            //shadow styles
            shadow: this.properties.shadow
              ? {
                  // color: this.properties.darkTheme ? this.barService.shadowDarkThme:this.barService.shadowColor,
                  offsetX: 1,
                  offsetY: 1,
                  opacity: 0.5,
                  width: 6,
                }
              : false,
            //bar size
            pointWidth: 25,
            //datalabel styles
            dataLabels: {
              style: {
                backgroundColor: this.barService.transparentBackground,
                //datalabel border
                textOutline: 'none',
                //datalabel color
                color: this.properties.darkTheme
                  ? this.properties.dataLabelColor === 'default'
                    ? 'white'
                    : this.properties.dataLabelColor ||
                      this.barService.darkThemeTextColor
                  : this.properties.dataLabelColor === 'default'
                  ? 'black'
                  : this.properties.dataLabelColor ||
                    this.barService.defaultThemeTextColor,
                //datalabel font size
                fontSize: this.properties.dataLabelSize,
                fontWeight: 'normal',
                fontFamily: this.barService.textfont,
              },
              y: -30,
              overflow: 'allow',
              crop: false,
              //enable the datalabel based on selection
              enabled: this.properties.showDataLabel,
              //datalabel is shown inside the bar
              inside: false,

              //datalabel alignment
              align: 'center',
              //datalabel overlap is set to true by default
              allowOverlap: true,
              //datalabel position
              verticalAlign: this.properties.dataLabelPosition,

              formatter: function (this: any) {
                //significance and changeVs option is selected from datalabel property
                if (properties.datalabelStyle == 'significance + changeVs') {
                  //if roundedvalue extracted is null show NA, else if % option from datalabel format is selected then add % to the datalabel text
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  //extract each changeVs value
                  let changeText =
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  //extarct each signififcance value
                  let sig =
                    this.series.userOptions.significance[this.point.x - 1];
                  //set the significance arrow according to its value
                  let s =
                    sig > 0
                      ? serviceBar.upwardTriangle
                      : sig < 0
                      ? serviceBar.downwardTriangle
                      : '';
                  //assign color to the arrow
                  let sigcolor =
                    sig > 0
                      ? serviceBar.highSignificance
                      : sig < 0
                      ? serviceBar.lowSignificance
                      : '';
                  //include + if changeValue is positive
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  //merge text+changeText+significance
                  let finalText =
                    '<span>' +
                    '<span>' +
                    text +
                    '</span>' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null && changeText
                      ? '<span>&nbsp' +
                        '<span style="font-size: ' +
                        serviceBar.changeValueFontSize +
                        ';color:' +
                        (properties.darkTheme
                          ? serviceBar.darkThemeTextColor
                          : serviceBar.defaultThemeTextColor) +
                        '; margin-left:3px;">(' +
                        changeText +
                        ')</span>&nbsp;' +
                        '<span style="color:' +
                        sigcolor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  //assign the finalText to tooltip
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  //return the finalText
                  return finalText;
                }
                if (properties.datalabelStyle == 'change') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  let changeText =
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  let finalText =
                    '<span>' +
                    text +
                    '  ' +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null && changeText
                      ? '<span>&nbsp' +
                        '<span style="font-size: ' +
                        serviceBar.changeValueFontSize +
                        ';color:' +
                        (properties.darkTheme
                          ? serviceBar.darkThemeTextColor
                          : serviceBar.defaultThemeTextColor) +
                        ';margin-left:3px; ">(' +
                        changeText +
                        ')</span>&nbsp;' +
                        '</span>'
                      : '');
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                }

                if (properties.datalabelStyle == 'ls') {
                  let text =
                    parseFloat(
                      this.series.userOptions.sampleSize[this.point.x - 1]
                    ) > serviceBar.sampleSizeConstant
                      ? this.series.userOptions.roundedValue[
                          this.point.x - 1
                        ] != null
                        ? this.y +
                          (properties.datalabelFormat == 'percentage'
                            ? '%'
                            : '')
                        : serviceBar.nullValueText
                      : serviceBar.lowSampleText;
                  let finalText = text + '<span style="opacity: 0.5;margin-left:3px;"></span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;

                  return finalText;
                }
                if (properties.datalabelStyle == 'significance') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  let sig =
                    this.series.userOptions.significance[this.point.x - 1];
                  let s =
                    sig > 0
                      ? serviceBar.upwardTriangle
                      : sig < 0
                      ? serviceBar.downwardTriangle
                      : '';
                  let sigcolor =
                    sig > 0
                      ? serviceBar.highSignificance
                      : sig < 0
                      ? serviceBar.lowSignificance
                      : '';
                  let finalText =
                    '<span >' +
                    text +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? '&nbsp<span style="color:' +
                        sigcolor +
                        ';margin-left:3px;">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return finalText;
                }
                if (properties.datalabelStyle == 'default') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;

                  this.series.userOptions.tooltip[this.point.x - 1] = text;
                  return '<span >' + text + '</span>';
                }
                if (properties.datalabelStyle == 'datalabel') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  this.series.userOptions.tooltip[this.point.x - 1] = text;
                  return '<span >' + text + '</span>';
                }

                if (properties.datalabelStyle == 'significance2') {
                  let text =
                    this.series.userOptions.roundedValue[this.point.x - 1] !=
                    null
                      ? this.y +
                        (properties.datalabelFormat == 'percentage' ? '%' : '')
                      : serviceBar.nullValueText;
                  let changeText =
                    this.series.userOptions.changeValueSeries[this.point.x - 1];
                  let sig =
                    this.series.userOptions.significance[this.point.x - 1];
                  let sig1 =
                    this.series.userOptions.significance2[this.point.x - 1];
                  let sColor =
                    sig > 0
                      ? serviceBar.highSignificance
                      : sig < 0
                      ? serviceBar.lowSignificance
                      : '';
                  let s =
                    sig > 0
                      ? serviceBar.upwardTriangle
                      : sig < 0
                      ? serviceBar.downwardTriangle
                      : '';
                  let changeColor =
                    sig1 < 0
                      ? serviceBar.lowSignificance
                      : sig1 > 0
                      ? serviceBar.highSignificance
                      : properties.darkTheme
                      ? serviceBar.darkThemeTextColor
                      : serviceBar.defaultThemeTextColor;

                  if (parseFloat(changeText) > 0) {
                    changeText = '+' + changeText;
                  }
                  let finalText =
                    '<span>' +
                    text +
                    (this.series.userOptions.roundedValue[this.point.x - 1] !=
                      null && changeText
                      ? '&nbsp<span style="color:' +
                        (properties.darkTheme
                          ? serviceBar.darkThemeTextColor
                          : serviceBar.defaultThemeTextColor) +
                        ' "> ' +
                        '<span style="font-size:' +
                        serviceBar.changeValueFontSize +
                        '; color:' +
                        changeColor +
                        ';margin-left:3px;">(' +
                        changeText +
                        ')</span>&nbsp' +
                        '<span style="color:' +
                        sColor +
                        ';">' +
                        s +
                        '</span>'
                      : '') +
                    '</span>';
                  this.series.userOptions.tooltip[this.point.x - 1] = finalText;
                  return finalText;
                }
                return !Number.isNaN(
                  this.series.userOptions.roundedValue[this.point.x - 1]
                )
                  ? this.y
                  : 'NA';
              },
            },
          },
        },
        series: this.seriesData1,
      } as Highcharts.Options);
    }

  }

  userselectedproperties() {

    this.data["properties"][0] = this.properties;

    return JSON.stringify(this.data).toString();
  }

  index = -1;

  getPatternForImage(imageUrl: any) {
    return {
      pattern: {
        image: imageUrl,
        aspectRatio: 9 / 4
      }
    };
  }

  customization(): Observable<{ list: any[]; metricDropdownOutput: any }> {
    // return this.barService.VerticalBarcustomizationList();
      const snapshotTypeSelectedName = this._customSnapshotService.selectedSnapshotType?.name;
    const cohortType = snapshotTypeSelectedName && snapshotTypeSelectedName.toLowerCase().includes('audience') 
      ? this._configService.audienceCohortType 
      : 'NA';
   
    return this._customSnapshotService.getChartCustomization("Vertical Bar Chart ", this._customSnapshotService.selectedSnapshotType?.name,cohortType);

  }

  applycustomization(event: any, item: string) {
    this.event = event;
    //choose the appropriate customization
    this.barService.applycustomization(event, item, this.properties)
    this.getBarChart('chart-container' + this.id, this.seriesData1, this.properties);
  }
  getTickInterval(maxBarValue: number, precision: number = 0.05): number {
    if (maxBarValue <= 0) return 0.05;

    const desiredTickCount = 4;
    const rawInterval = maxBarValue / desiredTickCount;

    const step = 1 / precision;
    const rounded = Math.ceil(rawInterval * step) / step;

    return rounded + 0.01;
  }
  transformRowChild(data: any[]): any[] {
  if (!data || data.length === 0) return data;

  return data.map(item => {
    return {
      ...item,
      data: item.data.map((d: any) => {
        const parts = d.rowChild
          ?.split('|')
          .map((p: string) => p.trim()) || [];

        if (parts.length === 0) return d;

        const last = parts[parts.length - 1]?.toLowerCase();
        let updatedRowChild = '';

        if (last === 'yes') {
          // Take two parts before "Yes"
          if (parts.length >= 3) {
            updatedRowChild = `${parts[parts.length - 3]} | ${parts[parts.length - 2]}`;
          } else {
            updatedRowChild = parts[0] || '';
          }
        } else {
          // For "no" and all other cases: take last two parts
          if (parts.length >= 2) {
            updatedRowChild = `${parts[parts.length - 2]} | ${parts[parts.length - 1]}`;
          } else {
            updatedRowChild = parts[0] || '';
          }
        }

        return {
          ...d,
          rowChild: updatedRowChild
        };
      })
    };
  });
}




  private updateSigSub: Subscription | null = null;

  ngOnDestroy(): void {
    this.updateSigSub?.unsubscribe();
    this.subscriptions.unsubscribe();
    if (this.chart) {
      this.chart.destroy();
      this.chart = null;
    }
  }
}





